import "./index.scss";
import dictionary from "../../dictionary";
import { useTranslation } from "react-i18next";
type Props = {
  onClick?: (item: string) => void;
};

const BreadCrumb = ({ onClick }: Props) => {
  const items = window.location.pathname
    .split("/")
    .filter((path) => path.length > 0);
  const { t } = useTranslation();
  return (
    <div id="bread-crumb-container">
      {items.map((item, index) =>
        items.length - 1 > index ? (
          <div className="direction-name" key={index}>
            <span>{t(dictionary.breadcrumbDictionary(item) as string)}</span>
          </div>
        ) : (
          <div className="main-page-name" key={index}>
            <span>{t(dictionary.breadcrumbDictionary(item) as string)}</span>
          </div>
        )
      )}
    </div>
  );
};

export default BreadCrumb;
